import aboutUs from '@/assets/modules/aboutUs.png';
import accommodations from '@/assets/modules/accommodations.png';
import accommodationList from '@/assets/modules/accommodationList.png';
import banner from '@/assets/modules/banner.jpg';
import bannerWithMenu from '@/assets/modules/bannerWithMenu.png';
import contact from '@/assets/modules/contact.png';
import contentBlock from '@/assets/modules/contentBlock.jpg';
import contentSlider from '@/assets/modules/contentSlider.png';
import countdown from '@/assets/modules/countdown.png';
import customForm from '@/assets/modules/customForm.png';
import customHTML from '@/assets/modules/customHTML.png';
import destinations from '@/assets/modules/destinations.png';
import EmbedGoogleMaps from '@/assets/modules/embed-google-maps.png';
import eventsMulti from '@/assets/modules/eventsMulti.png';
import footer from '@/assets/modules/footer.png';
import formLgpd from '@/assets/modules/form-lgpd.jpg';
import optinImagem from '@/assets/modules/optinImagem.png';
import hotelsList from '@/assets/modules/hotelsList.png';
import icons from '@/assets/modules/icons.png';
import imageFullWidth from '@/assets/modules/image-full-width.png';
import images2Columns from '@/assets/modules/images-2-columns.jpg';
import maps from '@/assets/modules/maps.jpg';
import optinBasico from '@/assets/modules/optinBasico.png';
import optinCompleto from '@/assets/modules/optinCompleto.png';
import optinSMS from '@/assets/modules/optinSMS.png';
import photosMosaic from '@/assets/modules/photosMosaic.png';
import preCheckIn from '@/assets/modules/preCheckIn.jpg';
import promoMulti from '@/assets/modules/promoMulti.png';
import promoSingle from '@/assets/modules/promoSingle.png';
import PromoList from '@/assets/modules/PromoList.png';
import partnersAwards from '@/assets/modules/partnersAwards.png';
import services from '@/assets/modules/services.jpg';
import simpleFAQ from '@/assets/modules/simpleFAQ.png';
import testimonials from '@/assets/modules/testimonials.png';
import widget from '@/assets/modules/widget.jpg';
import widgetLight from '@/assets/modules/widgetLight.png';
import social from '@/assets/modules/social.png';
import backgroundText from '@/assets/modules/backgroundText.png';
import experiences from '@/assets/modules/experiences.png';
import singleRoom from '@/assets/modules/singleRoom.png';
import singleDestination from '@/assets/modules/singleDestination.jpg';
import singlePromotion from '@/assets/modules/singlePromotion.png';
import newHeader from '@/assets/modules/newHeader.png';
import newFooter from '@/assets/modules/newFooter.png';
import columnSlider from '@/assets/modules/columnSlider.png';
import supportHeader from '@/assets/modules/supportHeader.png';
import linksFooter from '@/assets/modules/linksFooter.png';
import mosaicWithText from '@/assets/modules/mosaicWithText.png';
import amenitiesSlider from '@/assets/modules/amenitiesSlider.png';
import videoWindow from '@/assets/modules/videoWindow.png';
import CardList from '@/assets/modules/CardList.png';
import experienceList from '@/assets/modules/experienceList.png';
import highlightTitle from '@/assets/modules/highlightTitle.png';
import thumbsGallery from '@/assets/modules/thumbsGallery.png';
import promoHotel from '@/assets/modules/promoHotel.png';

import moduleCategory from '@/store/dicts/moduleCategory';
import isWithinLast30Days from '@/helpers/isWithinLast30Days';

const thirtyDaysFromNow = new Date(
  Number(new Date()) + 1000 * 60 * 60 * 24 * 30,
);

function orderList(list) {
  return list.sort((itemA, itemB) => itemA.name.localeCompare(itemB.name));
}

function newFirst(list) {
  return list.sort((itemA, itemB) => {
    if (!!itemA.isNew === !!itemB.isNew) {
      return 0;
    }

    return itemB.isNew ? 1 : -1;
  });
}

const presetList = [
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.ACCOMMODATIONS],
    name: 'Acomodações',
    module: 'Accommodations',
    keywords: ['letsbook', 'quartos'],
    image: accommodations,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: "Rockin' Hotel com Site Let's Book",
      subtitle: 'Subtitulo',
    },
  },
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.ACCOMMODATIONS],
    name: 'Lista de acomodações',
    module: 'AccommodationList',
    keywords: ['letsbook', 'quartos'],
    image: accommodationList,
    createdAt: '2023/11/13',
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Nossas acomodações',
      subtitle: 'à sua disposição no hotel',
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES, moduleCategory.SLIDERS],
    name: 'Carrossel de Banners',
    module: 'Banner',
    keywords: [],
    image: banner,
    data: {
      logo: 'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/pt/logo/1660243697256-logo_letsbook.png',
      banners: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/letsrock/1599856229698-banner.jpg',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/letsrock/1600700247766-banner-mobile.jpg',
          title: 'Aproveite fevereiro com 30% de desconto',
          subtitle: 'Tarifas a partir de R$ 250,00',
        },
      ],
    },
  },
  {
    category: [
      moduleCategory.CONTENT_IMAGES,
      moduleCategory.HEADER_FOOTER,
      moduleCategory.SLIDERS,
    ],
    name: 'Carrossel de Banners + menu',
    module: 'BannerWithMenu',
    keywords: ['cabeçalho', 'header'],
    image: bannerWithMenu,
    data: {
      logoImg:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/pt/logo/1660243697256-logo_letsbook.png',
      backgroundColor: '#000000',
      opacity: 0.5,
      buttons: [{ buttonText: 'Reserve' }],
      banners: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1616432771325-bannerwithmenu.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1616432771325-bannerwithmenu.png',
          title:
            'O seu evento nos melhores hotéis do Brasil com 30% de desconto',
          subtitle: 'Tarifas a partir de R$ 250,00',
        },
      ],
    },
    isEnabled() {
      return false;
    },
  },
  {
    category: [moduleCategory.HEADER_FOOTER],
    name: 'Cabeçalho',
    module: 'Menu',
    keywords: ['cabeçalho', 'header'],
    image: newHeader,
    data: {
      logoImg:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/pt/logo/1660243697256-logo_letsbook.png',
      backgroundColor: '#1F1F1F',
      opacity: 1.0,
      buttons: [{ buttonText: 'Reserve' }],
    },
  },
  {
    category: [moduleCategory.LETSBOOK],
    name: 'Buscador Letsbook',
    module: 'Widget',
    keywords: ['letsbook'],
    image: widget,
    unique: true,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
  },
  {
    category: [moduleCategory.LETSBOOK],
    name: 'Buscador Letsbook 2',
    module: 'WidgetLight',
    keywords: ['letsbook'],
    image: widgetLight,
    unique: true,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
  },
  {
    category: [moduleCategory.CONTENT_TEXT],
    name: 'Contagem Regressiva',
    module: 'Countdown',
    keywords: [],
    image: countdown,
    data: {
      title: 'É hora de aproveitar nossas ofertas!',
      subtitle: 'Quando o desconto é bom, a gente não pode perder tempo',
      text: 'É o tempo que falta para essa promoção imperdível! Fique ligado e não perca essa chance.',
      titleAfterCountdown: 'A promoção começou!',
      subtitleAfterCountdown: 'Não perca tempo e faça sua reserva',
      textAfterCountdown:
        'Quando o desconto é bom, a gente não pode perder tempo. Aproveite agora!',
      date: thirtyDaysFromNow.toISOString(),
    },
  },
  {
    category: [moduleCategory.LEADS, moduleCategory.CRM],
    name: 'Contato',
    module: 'Contact',
    keywords: ['formulário', 'crm'],
    image: contact,
    isEnabled({ hasCRMIntegration }) {
      return hasCRMIntegration;
    },
    data: {
      title: 'Fale conosco',
      subtitle: '',
      text: '',
      successMessage: 'Obrigado pela sua mensagem. Responderemos em breve!',
      useCrm: true,
      subjects: [
        {
          subject: '',
          emails: [],
          crmIdsNewPeople: [], // necessário para que seja validado
          crmIdsKnownPeople: [],
        },
      ],
    },
  },
  {
    category: [moduleCategory.LEADS, moduleCategory.CRM],
    name: 'Contato',
    module: 'Contact',
    keywords: ['formulário', 'crm'],
    image: contact,
    isEnabled({ hasCRMIntegration }) {
      return !hasCRMIntegration;
    },
    data: {
      title: 'Fale conosco',
      subtitle: '',
      text: '',
      successMessage: 'Obrigado pela sua mensagem. Responderemos em breve!',
      useCrm: false,
      subjects: [
        {
          subject: '',
          emails: [],
          crmIdsNewPeople: [], // necessário para que seja validado
          crmIdsKnownPeople: [],
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_TEXT, moduleCategory.SLIDERS],
    name: 'Depoimentos',
    module: 'Testimonials',
    keywords: [],
    image: testimonials,
    data: {
      testimonialsPrimaryColor: '#474747',
      testimonialsSecondaryColor: '#3E9AA6',
      titleColor: '#FFFFFF',
      title: 'Depoimentos',
      testimonialColor: '#FFFFFF',
      testimonials: [
        {
          testimonial:
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis doloribus, possimus at laudantium esse repudiandae aliquid magni, sit, tempore officia, sapiente cupiditate eos. Blanditiis eveniet consectetur eaque veritatis at optio! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis doloribus, possimus at laudantium esse repudiandae aliquid magni, sit, tempore officia, sapiente cupiditate eos.</p>',
          author: 'José Joaquim, Tripadvisor',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609272485265-depoimento-1.png',
        },
        {
          testimonial:
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis doloribus, possimus at laudantium esse repudiandae aliquid magni, sit, tempore officia, sapiente cupiditate eos. Blanditiis eveniet consectetur eaque veritatis at optio! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis doloribus, possimus at laudantium esse repudiandae aliquid magni, sit, tempore officia, sapiente cupiditate eos.</p>',
          author: 'Maria Melo, Tripadvisor',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609272515444-depoimento-2.png',
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES, moduleCategory.SLIDERS],
    name: 'Slider de Itens',
    module: 'Destinations',
    keywords: [],
    image: destinations,
    data: {
      title: 'Destinos',
      subtitle:
        'Conheça nossos hotéis pelo Brasil e escolha seu próximo destino',
      text: '',
      items: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372352751-ilha-de-marajo.png',
          title: 'Ilha de Marajó',
          buttonText: 'Ver destino',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372345892-praia-do-pontal.png',
          title: 'Praia do Pontal',
          buttonText: 'Ver destino',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372336935-porto-de-galinhas.png',
          title: 'Porto de Galinhas',
          buttonText: 'Ver destino',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372236892-campos-do-jordao.png',
          title: 'Campos do Jordão',
          buttonText: 'Ver destino',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372229200-aracatuba.png',
          title: 'Araçatuba',
          buttonText: 'Ver destino',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372289340-pocos-de-caldas.png',
          title: 'Poços de Caldas',
          buttonText: 'Ver destino',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372211380-foz-do-iguacu.png',
          title: 'Foz do Iguaçú',
          buttonText: 'Ver destino',
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES, moduleCategory.SLIDERS],
    name: 'Galeria com texto',
    module: 'ContentBlock',
    keywords: [],
    image: contentBlock,
    data: {
      title: 'Título de exemplo',
      subtitle: 'Subtítulo do texto',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tincidunt arcu et ultricies ultrices. Morbi vel scelerisque odio. Donec porttitor orci lorem, vitae gravida diam cursus at. Pellentesque eu dolor vitae ipsum egestas maximus et at nisi. Aliquam viverra et urna a molestie. Ut nec maximus lacus, pharetra rutrum diam. Sed malesuada nunc lorem, quis posuere justo tincidunt sit amet. Cras aliquet libero a bibendum pulvinar. Pellentesque viverra eros mollis velit vulputate, quis laoreet ipsum facilisis. Vestibulum fermentum mi non diam gravida posuere. Morbi varius auctor tellus, sed convallis ipsum pretium semper. Proin mi justo, hendrerit facilisis porta eu, hendrerit eu nulla. Sed ac felis volutpat, iaculis augue vel, vulputate massa. Ut eget posuere odio. Sed et quam consequat, euismod nisl eget, malesuada ante. Nunc at metus laoreet, molestie sapien non, rutrum sem. Donec vel tempus velit. Phasellus convallis est at neque mattis imperdiet at ac turpis. Morbi nisl est, egestas eget neque nec, efficitur varius nibh. In in mi id tellus auctor semper sed eu tortor. Etiam tempor erat non dui pretium, vel mattis tortor tempor. Suspendisse id dui risus. Donec vel venenatis dolor.',
      textPosition: 'row',
      swiperAutoplaySpeed: 10,
      buttons: [
        {
          buttonText: 'Conheça o hotel',
          buttonFeatured: false,
        },
      ],
      slides: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/lets-rock/1607096447488-uocsnwmhnas.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/lets-rock/1607096447488-uocsnwmhnas.png',
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_TEXT],
    name: 'Perguntas Frequentes',
    module: 'SimpleFAQ',
    keywords: [],
    image: simpleFAQ,
    data: {
      title: 'Título de exemplo',
      subtitle: 'Subtítulo do texto',
      categories: [
        {
          category: 'About the hotel',
        },
        {
          category: 'About the park',
        },
        {
          category: 'About the restaurant',
        },
      ],
      showCategories: false,
      questions: [
        {
          questionCategory: '',
          question: 'What is Lorem Ipsum?',
          answer:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          buttonText: '',
          showButton: false,
        },
        {
          questionCategory: '',
          question: 'Where does it come from?',
          answer:
            'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, comes from a line in section 1.10.32.',
          buttonText: '',
          showButton: false,
        },
        {
          questionCategory: '',
          question: 'Why do we use it?',
          answer:
            "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
          buttonText: 'Saiba mais',
          showButton: true,
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Fotos + texto em colunas',
    module: 'Icons',
    keywords: [],
    image: icons,
    data: {
      sectionTitle: 'Título do bloco de até 40 caracteres',
      sectionSubtitle: 'Subtítulo do texto',
      items: [
        {
          title: 'Título 1',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1608037497960-praia.png',
          imageAltText: 'Texto alternativo',
          buttonText: 'Saiba mais',
          buttonUrl: {
            type: 'externalLink',
            value: '#',
            openInNewTab: true,
          },
        },
        {
          title: 'Título 2',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1608037376865-hospital.png',
          imageAltText: 'Texto alternativo',
          buttonText: 'Saiba mais',
          buttonUrl: {
            type: 'externalLink',
            value: '#',
            openInNewTab: true,
          },
        },
        {
          title: 'Título 3',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1608037411545-loja.png',
          imageAltText: 'Texto alternativo',
          buttonText: 'Saiba mais',
          buttonUrl: {
            type: 'externalLink',
            value: '#',
            openInNewTab: true,
          },
        },
        {
          title: 'Título 4',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1608037546392-estacionamento.png',
          imageAltText: 'Texto alternativo',
          buttonText: 'Saiba mais',
          buttonUrl: {
            type: 'externalLink',
            value: '#',
            openInNewTab: true,
          },
        },
      ],
    },
  },
  {
    category: [moduleCategory.LETSBOOK],
    name: 'Lista de hotéis',
    module: 'HotelsList',
    keywords: ['letsbook'],
    image: hotelsList,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Nossos Hotéis',
      subtitle: 'Temos opções incríveis nos melhores destinos do Brasil',
      showFilter: true,
      titleColor: '#333333',
      subtitleColor: '#333333',
    },
  },
  {
    category: [moduleCategory.OTHERS],
    name: 'Estrutura de eventos',
    module: 'EventsMulti',
    image: eventsMulti,
    data: {
      title: 'Eventos',
      subtitle: 'Estruturas ideais para sua necessidade',
      backgroundImage: '',
      botaoTexto: 'SOLICITE UM ORÇAMENTO',
      backgroundColorBtnOrcar: '#3e9aa6',
      textColorBtnOrcar: '#ffffff',
      iconColor: '#3e9aa6',
      hoteis: [
        {
          nomeHotel: 'NOME DE UM HOTEL',
          material:
            'https://s3.amazonaws.com/projetos.campaign/editor/kelvin/kelvao/1610132102901-arquivo.pdf',
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Mosaico',
    module: 'PhotosMosaic',
    keywords: [],
    image: photosMosaic,
    data: {
      media: [
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705277013-galeria-01.jpg',
        },
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705290764-galeria-02.jpg',
        },
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705304075-galeria-03.jpg',
        },
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705316730-galeria-04.jpg',
        },
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705330439-galeria-05.jpg',
        },
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705342621-galeria-06.jpg',
        },
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705355732-galeria-07.jpg',
        },
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1607705369546-galeria-08.jpg',
        },
      ],
    },
  },
  {
    category: [moduleCategory.LEADS],
    name: 'Formulário de LGPD',
    module: 'FormLgpd',
    keywords: ['formulário'],
    image: formLgpd,
    isEnabled({ customerSettings }) {
      const { lgpdRecipients } = customerSettings;

      return Array.isArray(lgpdRecipients) && lgpdRecipients.length > 0;
    },
    data: {
      title: 'Direitos dos Titulares dos Dados',
      subtitle: 'Você no controle dos seus dados pessoais',
      text: '<p>Reconhecemos que os seus dados pessoais são seus, por isso preparamos essa página para que você possa exercer seus direitos de forma simples e transparente, conforme a lei 13.709/2018 - Lei Geral de Proteção de Dados (LGPD). Confirme abaixo suas informações pessoais e escolha se quer consultar, alterar ou excluir seus dados.</p>',
      removeConfirmationText:
        '<span style="background-color: lime;">TEXTO DE MARCAÇÃO. CONSULTE SEU DEPARTAMENTO JURÍDICO E ALTERE OS TERMOS ANTES DE PUBLICAR SUA PÁGINA.</span>',
      successMessage:
        'Obrigado. Sua solicitação foi registrada e você receberá uma confirmação por e-mail em breve.',
      extraFields: [],
    },
  },
  {
    category: [moduleCategory.LEADS, moduleCategory.CRM],
    name: 'Formulário com imagem',
    module: 'FormWithImage',
    keywords: ['formulário', 'crm'],
    image: optinImagem,
    isEnabled({ hasCRMIntegration }) {
      return hasCRMIntegration;
    },
    data: {
      title: 'Cadastre-se e receba nossas ofertas',
      subtitle: 'E fique por dentro de todas as novidades',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc in diam leo. Cras vitae porta lectus. Nullam auctor faucibus quam quis bibendum.',
      formTitle: 'Preencha o formulário e aproveite!',
      consentText: 'Aceito receber comunicações do hotel.',
      successMessage: 'Obrigado pelo seu cadastro!',
      ctaColor: '#3E9AA6',
      backgroundImageDesk:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1597692279997-banner.jpg',
    },
  },
  {
    category: [moduleCategory.LEADS, moduleCategory.CRM],
    name: 'Opt-in Completo',
    module: 'Form',
    keywords: ['formulário', 'crm'],
    image: optinCompleto,
    isEnabled({ hasCRMIntegration }) {
      return hasCRMIntegration;
    },
    data: {
      title: 'Cadastre-se e receba nossas melhores ofertas',
      successMessage: 'Obrigado pela sua inscrição.',
    },
  },
  {
    category: [moduleCategory.LEADS, moduleCategory.CRM],
    name: 'Opt-in Básico',
    module: 'BasicOptin',
    keywords: ['formulário', 'crm'],
    image: optinBasico,
    isEnabled({ hasCRMIntegration }) {
      return hasCRMIntegration;
    },
    data: {
      title: 'Receba nossas melhores ofertas',
      successMessage:
        'Tudo certo! A partir de agora você receberá nossos e-mails.',
    },
  },
  {
    category: [moduleCategory.LEADS, moduleCategory.CRM],
    name: 'Opt-in SMS',
    module: 'OptinSMS',
    keywords: ['formulário', 'crm'],
    image: optinSMS,
    isEnabled({ hasCRMIntegration }) {
      return hasCRMIntegration;
    },
    data: {
      title: 'Receba nossas melhores ofertas',
      successMessage:
        'Tudo certo! A partir de agora você receberá nossos e-mails.',
    },
  },
  {
    category: [moduleCategory.SLIDERS, moduleCategory.LETSBOOK],
    name: 'Serviços',
    module: 'Services',
    keywords: [],
    image: services,
    data: {
      title: 'Lazer e serviços',
      subtitle: 'à sua disposição no hotel',
      textPosition: 'row-reverse',
      slides: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1611253968101-1.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1611253968101-1.png',
        },
      ],
      services: [
        {
          serviceName: 'Ar-Condicionado',
        },
        {
          serviceName: 'Banheira',
        },
        {
          serviceName: 'Piscina',
        },
      ],
      hotel: null,
    },
  },
  {
    category: [
      moduleCategory.CONTENT_IMAGES,
      moduleCategory.CONTENT_TEXT,
      moduleCategory.SLIDERS,
    ],
    name: 'Slider de conteúdo',
    module: 'ContentSlider',
    keywords: [],
    image: contentSlider,
    data: {
      mainTitle: 'Serviços',
      mainSubtitle: 'à sua disposição no  hotel',
      mainText: '',
      slides: [
        {
          title: 'Lorem ipsum dolor sit  adipiscing elit ut aliquam',
          subtitle: 'Lorem ipsum dolor sit amet, consectetur',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie lorem, nec efficitur elit ante vitae erat. Duis ex justo, feugiat at arcu ut, pharetra aliquam tortor. Sed commodo purus a mauris tempus dictum. Praesent maximus luctus feugiat. Sed quis porttitor libero, sed viverra libero. Nullam nec.',
          textPosition: 'row-reverse',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1618510426885-frame-86.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1618510426885-frame-86.png',
          showButton: true,
          buttonText: 'Reserve aqui',
          buttonFeatured: true,
        },
        {
          title: 'Lorem ipsum dolor sit  adipiscing elit ut aliquam',
          subtitle: 'Lorem ipsum dolor sit amet, consectetur',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie lorem, nec efficitur elit ante vitae erat. Duis ex justo, feugiat at arcu ut, pharetra aliquam tortor. Sed commodo purus a mauris tempus dictum. Praesent maximus luctus feugiat. Sed quis porttitor libero, sed viverra libero. Nullam nec.',
          textPosition: 'row-reverse',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1618510365863-frame-87.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1618510365863-frame-87.png',
          showButton: false,
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES, moduleCategory.SLIDERS],
    name: 'Slider em colunas',
    module: 'ColumnSlider',
    keywords: [],
    image: columnSlider,
    data: {
      title: 'Slider em colunas',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie.',
      slides: [
        {
          title: 'Lorem ipsum dolor sit  adipiscing elit ut aliquam',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie lorem, nec efficitur elit ante vitae erat. Duis ex justo, feugiat at arcu ut, pharetra aliquam tortor. Sed commodo purus a mauris tempus dictum. Praesent maximus luctus feugiat. Sed quis porttitor libero, sed viverra libero. Nullam nec.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372352751-ilha-de-marajo.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372352751-ilha-de-marajo.png',
          buttonText: 'Saiba mais',
        },
        {
          title: 'Lorem ipsum dolor sit  adipiscing elit ut aliquam',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie lorem, nec efficitur elit ante vitae erat. Duis ex justo, feugiat at arcu ut, pharetra aliquam tortor. Sed commodo purus a mauris tempus dictum. Praesent maximus luctus feugiat. Sed quis porttitor libero, sed viverra libero. Nullam nec.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372345892-praia-do-pontal.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372345892-praia-do-pontal.png',
          buttonText: 'Saiba mais',
        },
        {
          title: 'Lorem ipsum dolor sit  adipiscing elit ut aliquam',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie lorem, nec efficitur elit ante vitae erat. Duis ex justo, feugiat at arcu ut, pharetra aliquam tortor. Sed commodo purus a mauris tempus dictum. Praesent maximus luctus feugiat. Sed quis porttitor libero, sed viverra libero. Nullam nec.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372336935-porto-de-galinhas.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372336935-porto-de-galinhas.png',
          buttonText: 'Saiba mais',
        },
        {
          title: 'Lorem ipsum dolor sit  adipiscing elit ut aliquam',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie lorem, nec efficitur elit ante vitae erat. Duis ex justo, feugiat at arcu ut, pharetra aliquam tortor. Sed commodo purus a mauris tempus dictum. Praesent maximus luctus feugiat. Sed quis porttitor libero, sed viverra libero. Nullam nec.',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372236892-campos-do-jordao.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1610372236892-campos-do-jordao.png',
          buttonText: 'Saiba mais',
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_TEXT],
    name: 'Texto com fundo',
    module: 'BackgroundText',
    keywords: [],
    image: backgroundText,
    data: {
      backgroundType: 'image',
      backgroundImage:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/pt/default/1637845933722-foto-bnn.jpg',
      title: 'Conheça o Relaxing &  Wellness Spa',
      text: 'Viva uma jornada sensorial no nosso Spa e desfrute de massagens relaxantes, cromoterapias, aromaterapias e muito mais!',
      buttons: [
        {
          buttonText: 'Conhecer',
          buttonUrl: {
            type: 'externalLink',
            value: '#',
            openInNewTab: true,
          },
        },
        {
          buttonText: 'Agendar',
          buttonFeatured: true,
          buttonUrl: {
            type: 'externalLink',
            value: '#',
            openInNewTab: true,
          },
        },
      ],
    },
  },

  {
    category: [moduleCategory.CONTENT_TEXT],
    name: 'Quem Somos',
    module: 'AboutUs',
    keywords: [],
    image: aboutUs,
    data: {
      title: 'Texto de exemplo',
      subtitle: 'Subtítulo do texto',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis rem natus ipsam quod aut neque, dolorem officiis nemo tenetur odio delectus quos, eum modi, nisi. Hic fugit dolores illo, ullam.Fugit voluptatem molestias alias vero quia. Voluptatum sequi esse repudiandae nemo quos labore vel, optio illo itaque eum? Cumque dolorum consectetur fugit tenetur, perferendis quam totam earum natus recusandae voluptatum. Cumque voluptas aspernatur hic temporibus, reiciendis suscipit consequuntur nulla. Similique, quisquam aspernatur rerum laborum velit, facilis? Minus eos, dignissimos, quisquam quo vel ipsam. Dignissimos quam repudiandae alias aperiam assumenda explicabo?',
      cards: [
        {
          cardTitle: 'MISSÃO',
          cardDescription:
            'Sodales sed tristique in, aliquam eu magna. Cras metus turpis, maximus sit amet aliquet vitae, maximus in elit. Etiam hendrerit massa felis, quis tincidunt purus feugiat eget. Suspendisse a ullamcorper sapien. Nullam lectus sem, pellentesque quis mollis ut, lacinia non ligula. Sed quis lectus sed lacus accumsan laoreet. Suspendisse potenti. Mauris convallis porttitor nisl in laoreet. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.',
        },
        {
          cardTitle: 'VISÃO',
          cardDescription:
            'Sodales sed tristique in, aliquam eu magna. Cras metus turpis, maximus sit amet aliquet vitae, maximus in elit. Etiam hendrerit massa felis, quis tincidunt purus feugiat eget. Suspendisse a ullamcorper sapien. Nullam lectus sem, pellentesque quis mollis ut, lacinia non ligula. Sed quis lectus sed lacus accumsan laoreet. Suspendisse potenti. Mauris convallis porttitor nisl in laoreet. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.',
        },
        {
          cardTitle: 'VALORES',
          cardDescription:
            'Sodales sed tristique in, aliquam eu magna. Cras metus turpis, maximus sit amet aliquet vitae, maximus in elit. Etiam hendrerit massa felis, quis tincidunt purus feugiat eget. Suspendisse a ullamcorper sapien. Nullam lectus sem, pellentesque quis mollis ut, lacinia non ligula. Sed quis lectus sed lacus accumsan laoreet. Suspendisse potenti. Mauris convallis porttitor nisl in laoreet. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.',
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES, moduleCategory.SLIDERS],
    name: 'Parceiros/Prêmios',
    module: 'PartnersAwards',
    keywords: [],
    image: partnersAwards,
    data: {
      title: 'Nossos parceiros e prêmios',
      partners: [
        {
          name: '',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609875075112-1.png',
        },
        {
          name: '',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609875082829-2.png',
        },
        {
          name: '',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609875089971-3.png',
        },
        {
          name: '',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609875096435-4.png',
        },
        {
          name: '',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609875202014-5.png',
        },
        {
          name: '',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1609875208150-6.png',
        },
      ],
    },
  },
  {
    category: [
      moduleCategory.LEADS,
      moduleCategory.LETSBOOK,
      moduleCategory.CRM,
    ],
    name: 'Pré Check-in',
    module: 'PreCheckIn',
    keywords: ['letsbook'],
    image: preCheckIn,
    unique: true,
    updatedAt: '2023/12/07',
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      titleBoard: 'SUA CHEGADA NO HOTEL AINDA MAIS CONFORTÁVEL',
      subtitleBoard:
        'Fazendo o check-in online, não será necessário o preenchimento da ficha na sua chegada.',
      imageSuccess:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/default/1639677078333-complete_checkin.png',
      altImageSuccess: 'Pessoa na praia aproveitando a viagem',
      titleSuccess: 'Seu pré check-in está completo',
      subtitleSuccess: 'Quais são os próximos passos?',
      consentText: 'Aceito receber comunicações e ofertas do hotel.',
      stepsSuccess: [
        {
          icon: 'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/default/1639677720700-iconcheck.png',
          text: 'Pré check-in online confirmado.',
        },
        {
          icon: 'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/default/1639677823921-iconhotel.png',
          text: 'Ao chegar no hotel, é só se identificar e assinar.',
        },
        {
          icon: 'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/default/1639678006787-iconkey.png',
          text: 'Em instantes, pegue as chaves e aproveite!',
        },
      ],
    },
  },
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.PROMOTIONS],
    name: 'Promoções Multi',
    module: 'PromoMulti',
    keywords: ['letsbook'],
    image: promoMulti,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Promoções e pacotes',
      subtitle: 'Sua próxima viagem com preços e condições especiais',
    },
  },
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.PROMOTIONS],
    name: 'Lista de promoções',
    module: 'PromoList',
    keywords: ['letsbook'],
    image: PromoList,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Promoções',
      subtitle: 'Veja todas nossas promoções',
      showFilter: true,
      titleColor: '#333333',
      subtitleColor: '#333333',
    },
  },
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.PROMOTIONS],
    name: 'Promoções Single',
    module: 'PromoSingle',
    keywords: ['letsbook'],
    image: promoSingle,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Promoções e pacotes',
      subtitle: 'Descontos especiais para você curtir sua viagem',
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Imagem 100% de largura',
    module: 'ImageFullWidth',
    keywords: [],
    image: imageFullWidth,
    data: {
      image:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/default/1597691983903-photo-1540541338287-41700207dee6.jpg',
      imageMobile:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/gateste/1617909726016-device-example.png',
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Imagens em duas colunas',
    module: 'Images2Columns',
    keywords: [],
    image: images2Columns,
    data: {
      titleColor: '#474747',
      background: '#E5E5E5',
      blocks: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/pt/default/1650638829968-imagem-1.jpg',
          title: 'Momento relax para aproveitar com a família',
          description:
            'Curta todo o conforto e desfrute de momentos incríveis em nossos hotéis',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/pt/default/1650638842668-imagem-2.jpg',
          title: 'Os melhores destinos de Curitiba',
          description:
            'Destinos para quem busca se desconectar do cotidiano e se conectar com a natureza',
        },
      ],
    },
  },
  {
    category: [moduleCategory.HEADER_FOOTER],
    name: 'Rodapé Simples',
    module: 'Footer',
    keywords: ['footer'],
    image: footer,
    data: {
      logoImg:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/pt/logo/1660243697256-logo_letsbook.png',
      hotelName: 'Nome do hotel',
      phones: [
        {
          label: 'Reservas',
          ddi: '54',
          number: '3295 7555',
        },
      ],
      socialLinks: [
        {
          socialType: 'instagramLink',
          title: '',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.instagram.com/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'youTubeLink',
          title: '',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.youtube.com/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'facebookLink',
          title: '',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.facebook.com/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'tripAdvisorLink',
          title: '',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.tripadvisor.com.br/',
            openInNewTab: true,
          },
        },
      ],
    },
  },
  {
    category: [moduleCategory.HEADER_FOOTER],
    name: 'Rodapé Completo',
    module: 'NewFooter',
    keywords: ['footer'],
    image: newFooter,
    data: {
      hotelName: 'Nome do hotel',
      flagsOption: 'without',
      contacts: [
        {
          contactType: 'telefone',
          label: 'Reservas',
          ddi: '55',
          ddd: '51',
          number: '3295 7555',
        },
        {
          contactType: 'whatsapp',
          label: 'Whatsapp',
          ddi: '55',
          ddd: '51',
          number: '93295 7555',
        },
        {
          contactType: 'email',
          label: 'Suporte',
          email: 'example.mail@site.com.br',
        },
        {
          contactType: 'endereco',
          label: 'Endereço: Avenida Carlos Gomes, 700 Porto Alegre - RS',
          enableLinkURL: false,
        },
        {
          contactType: 'razao',
          label: 'PM Comunicação Ltda. CNPJ: 01.814.989/0001-30',
          enableLinkURL: false,
        },
      ],
      socialLinks: [
        {
          socialType: 'twitterLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.twitter.com/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'instagramLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.instagram.com/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'youTubeLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.youtube.com/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'facebookLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.facebook.com/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'linkedinLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.linkedin.com.br/',
            openInNewTab: true,
          },
        },
        {
          socialType: 'tripAdvisorLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.tripadvisor.com.br/',
            openInNewTab: true,
          },
        },
      ],
      termosType: 'modal',
      termosTitle: 'Termos de uso',
      politicasType: 'modal',
      politicasTitle: 'Política de privacidade',
      backgroundColorFooter: '#3e9aa6',
    },
  },
  {
    category: [moduleCategory.HEADER_FOOTER],
    name: 'Rodapé com links',
    module: 'LinksFooter',
    keywords: ['footer'],
    image: linksFooter,
    data: {
      backgroundColor: '#F8FAFC',
      textColor: '#52525B',
      linksColor: '#52525B',
      text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet, massa nec consequat gravida, leo neque molestie lorem, nec efficitur elit ante vitae erat. Duis ex justo, feugiat at arcu ut, pharetra aliquam tortor.</p>',
      socialLinks: [
        {
          id: '750019312969',
          socialType: 'twitterLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.twitter.com/',
            openInNewTab: true,
          },
          title: '',
        },
        {
          id: '617281936555',
          socialType: 'instagramLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.instagram.com/',
            openInNewTab: true,
          },
          title: '',
        },
        {
          id: '437792116548',
          socialType: 'youTubeLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.youtube.com/',
            openInNewTab: true,
          },
          title: '',
        },
        {
          id: '123057224846',
          socialType: 'facebookLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.facebook.com/',
            openInNewTab: true,
          },
          title: '',
        },
        {
          id: '1634275654778',
          socialType: 'linkedinLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.linkedin.com.br/',
            openInNewTab: true,
          },
          title: '',
        },
        {
          id: '367692880077',
          socialType: 'tripAdvisorLink',
          linkURL: {
            type: 'externalLink',
            value: 'https://www.tripadvisor.com.br/',
            openInNewTab: true,
          },
          title: '',
        },
      ],
      columnOneLinks: [
        {
          id: '373411252072',
          linkText: 'Primeiro link',
          linkUrl: {
            type: 'externalLink',
            value: '',
            openInNewTab: true,
          },
        },
        {
          id: '1198999646558',
          linkText: 'Segundo link',
          linkUrl: {
            type: 'externalLink',
            value: '',
            openInNewTab: true,
          },
        },
      ],
      columnTwoLinks: [
        {
          id: '959909793485',
          linkText: 'Terceiro link',
          linkUrl: {
            type: 'externalLink',
            value: '',
            openInNewTab: true,
          },
        },
        {
          id: '1682813115445',
          linkText: 'Quarto Link',
          linkUrl: {
            type: 'externalLink',
            value: '',
            openInNewTab: true,
          },
        },
      ],
      menuLinks: [
        {
          id: '722683384990',
          menuLinks: [],
          linkText: 'Pmweb',
          linkUrl: {
            type: 'externalLink',
            value: '',
            openInNewTab: true,
          },
        },
      ],
      bottomText: '<p>&copy; Copyright 2023.</p>',
    },
  },
  {
    category: [moduleCategory.OTHERS],
    name: 'Mapa',
    module: 'Maps',
    keywords: [],
    image: maps,
  },
  {
    category: [moduleCategory.OTHERS],
    name: 'Mapa do Google',
    module: 'EmbedGoogleMaps',
    keywords: [],
    image: EmbedGoogleMaps,
  },
  {
    category: [moduleCategory.OTHERS],
    name: 'Redes Sociais',
    module: 'Social',
    keywords: [],
    image: social,
    data: {
      sectionTitle: 'Siga nossas redes sociais',
      sectionSubtitle: 'E fique por dentro de todas as novidades e ofertas',
      items: [
        {
          socialIcon: 'twitterIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.twitter.com/',
            openInNewTab: true,
          },
          svgColor: '#34D9D9',
          text: 'Nos siga no Twitter',
        },
        {
          socialIcon: 'instagramIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.instagram.com/',
            openInNewTab: true,
          },
          svgColor: '#BE855C',
          text: 'Siga nosso Instagram',
        },
        {
          socialIcon: 'youTubeIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.youtube.com/',
            openInNewTab: true,
          },
          svgColor: '#E15858',
          text: 'Se inscreva no Youtube',
        },
        {
          socialIcon: 'facebookIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.facebook.com/',
            openInNewTab: true,
          },
          svgColor: '#409EE2',
          text: 'Curta no Facebook',
        },
        {
          socialIcon: 'linkedinIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.linkedin.com.br/',
            openInNewTab: true,
          },
          svgColor: '#058AB5',
          text: 'Acompanhe no LinkedIn',
        },
        {
          socialIcon: 'tripAdvisorIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.tripadvisor.com.br/',
            openInNewTab: true,
          },
          svgColor: '#38985E',
          text: 'Conheça no TripAdvisor',
        },
        {
          socialIcon: 'spotifyIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.spotify.com/br/',
            openInNewTab: true,
          },
          svgColor: '#56B065',
          text: 'Acompanhe nosso Spotify',
        },
        {
          socialIcon: 'tiktokIcon',
          buttonUrl: {
            type: 'externalLink',
            value: 'https://www.tiktok.com/',
            openInNewTab: true,
          },
          svgColor: '#000000',
          text: 'Nos siga no TikTok',
        },
      ],
    },
  },
  {
    category: [moduleCategory.LETSBOOK],
    name: 'Experiências',
    module: 'Experiences',
    keywords: ['letsbook'],
    image: experiences,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Experiências',
      subtitle: 'Deixe a sua viagem ainda mais completa',
    },
  },
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.ACCOMMODATIONS],
    name: 'Quarto Avulso',
    module: 'SingleRoom',
    keywords: ['letsbook', 'acomodacoes'],
    image: singleRoom,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
  },
  {
    category: [moduleCategory.LETSBOOK],
    name: 'Destino Avulso',
    module: 'SingleDestination',
    keywords: ['letsbook'],
    image: singleDestination,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: '##CIDADE',
      subtitle: 'Conheça ##CIDADE',
      text: '##CIDADE<br>##ESTADO<br>##DESC',
      slides: [
        {
          type: 'image',
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/lets-rock/1607096447488-uocsnwmhnas.png',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/lets-rock/1607096447488-uocsnwmhnas.png',
        },
      ],
      buttons: [
        {
          buttonText: 'Reservar',
          buttonUseDestinationLink: true,
          buttonFeatured: true,
        },
      ],
    },
  },
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.PROMOTIONS],
    name: 'Promoção em destaque',
    module: 'SinglePromotion',
    keywords: ['promoção'],
    image: singlePromotion,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      slides: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/demo/letsrock/1599856229698-banner.jpg',
        },
      ],
    },
  },
  {
    category: [moduleCategory.HEADER_FOOTER],
    name: 'Cabeçalho de apoio',
    module: 'SupportHeader',
    keywords: ['cabeçalho', 'header', 'apoio'],
    image: supportHeader,
    data: {
      image:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/default/1685726617994-logo_letsbook_dark.png',
      backgroundColor: '#ffffff',
      textColor: '#474747',
      titleColor: '#474747',
      paddingTop: 0,
      paddingBottom: 0,
      paddingTopMobile: 0,
      paddingBottomMobile: 0,
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Mosaico de fotos com texto',
    module: 'MosaicWithText',
    image: mosaicWithText,
    keywords: ['texto', 'imagem', 'mosaico'],
    data: {
      title: 'Uma experiência inesquecível',
      subtitle: 'Para você jamais esquecer',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam. Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam Lorem ipsum dolor sit amet.',
      buttonTextColor: '#ffffff',
      buttonColor: '#3e9aa6',
      mosaic: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/_/1687284329635-rectangle-1239.jpg',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/_/1687284320829-rectangle-1240.jpg',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/_/1687284310809-rectangle-1241.jpg',
        },
      ],
      buttons: [
        {
          buttonText: 'Quero reservar',
          buttonUrl: '',
          buttonFeatured: true,
        },
      ],
    },
  },
  {
    category: [
      moduleCategory.LETSBOOK,
      moduleCategory.CONTENT_IMAGES,
      moduleCategory.SLIDERS,
    ],
    name: 'Slider com destaque',
    module: 'AmenitiesSlider',
    keywords: [],
    image: amenitiesSlider,
    data: {
      title: 'Uma experiência inesquecível',
      subtitle: 'Viva momentos inesquecíveis em meio a natureza',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In aliquam sem fringilla ut morbi tincidunt augue interdum.',
      slides: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1687354829626-fotis-fotopoulos-sqh7__rxjc8-unsplash.jpg',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1687354829626-fotis-fotopoulos-sqh7__rxjc8-unsplash.jpg',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1687354866389-young-kane-f_rmrzw4yn4-unsplash.jpg',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1687354866389-young-kane-f_rmrzw4yn4-unsplash.jpg',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1687354889192-dubai-travel-blog-pqkq3jncore-unsplash.jpg',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1687354889192-dubai-travel-blog-pqkq3jncore-unsplash.jpg',
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Vídeo em janela',
    module: 'VideoWindow',
    keywords: [],
    image: videoWindow,
    data: {
      title: 'Mais do que um hotel',
      buttonColor: '#ffffff',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In aliquam sem fringilla ut morbi tincidunt augue interdum.',
      image:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas/1689768400319-brooke-cagle-9a0zeq_f8rs-unsplash.jpg',
      thumbText: 'Veja o que nossos hóspedes dizem sobre a estadia',
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Lista de imagens com texto',
    module: 'CardList',
    keywords: [],
    image: CardList,
    data: {
      title: 'Seu momento relax no nosso hotel',
      titleWeight: '400',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In aliquam sem fringilla ut morbi tincidunt augue interdum.',
      cards: [
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/card-list/1690982242684-719beee8e5a61c375ae1c5e3237e3581.jpg',
          title: 'Aproveite nosso Spa',
          text: 'Massagens e pedras quentes',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/card-list/1690982226443-85a859ee6c6327d20832b247e034ad02.jpg',
          title: 'Drinks premiados',
          text: 'O nosso barman &eacute; premiado internacionalmente',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/card-list/1690982183001-0fbdbc7be9cb9fddd9858527b11c6843.jpg',
          title: 'Café e sabor',
          text: 'Para aquele momento tranquilo da tarde, um caf&eacute;zinho cai bem',
        },
        {
          image:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/card-list/1690982203884-2c8c72509f694eb556dc94f98839732a.jpg',
          imageMobile:
            'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/card-list/1690982203884-2c8c72509f694eb556dc94f98839732a.jpg',
          title: 'Natureza paradisíaca',
          text: 'Explore as nossas trilhas, praias',
        },
      ],
    },
  },
  {
    category: [moduleCategory.OTHERS],
    name: 'HTML customizado',
    module: 'CustomHTML',
    keywords: [],
    image: customHTML,
    data: {},
  },
  {
    category: [moduleCategory.LEADS, moduleCategory.CRM],
    name: 'Formulário customizado',
    module: 'CustomForm',
    keywords: ['formulário', 'crm'],
    image: customForm,
    data: {
      title: 'Faça seu evento conosco',
      subtitle: 'Nossa equipe adoraria ouvir de você.',
      buttonText: 'Solicitar cotação',
      image:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/tovo/1693871220943-customformimage.png',
      consentText:
        'Eu concordo com os <a href="" target="_blank">termos de uso</a> em receber comunicações do hotel.',
      successMessage: 'Obrigado pelo seu contato!',
      ctaColor: '#3E9AA6',
    },
  },
  {
    category: [moduleCategory.LETSBOOK],
    name: 'Lista de experiências',
    module: 'ExperienceList',
    updatedAt: '2023/11/13',
    keywords: ['letsbook'],
    image: experienceList,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Viva o agora com experiências incríveis',
      text: 'Uma coleção de momentos especiais, cuidadosamente criados por pessoas que conhecem os destinos e que amam surpreender e fazer novos amigos. A resposta para aqueles que buscam em uma viagem experiências únicas que transformam suas vidas e o ato de viajar.',
    },
  },
  {
    category: [moduleCategory.CONTENT_TEXT],
    name: 'Título em destaque',
    module: 'HighlightTitle',
    createdAt: '2024/01/02',
    keywords: ['letsbook'],
    image: highlightTitle,
    data: {
      title: 'O melhor hotel da Bahia é na Praia do Marinheiro',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor <br>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor',
      buttons: [
        {
          buttonText: 'Reserve',
          buttonFeatured: true,
        },
      ],
    },
  },
  {
    category: [moduleCategory.CONTENT_IMAGES],
    name: 'Galeria com miniaturas',
    module: 'ThumbsGallery',
    image: thumbsGallery,
    keywords: ['texto', 'imagem', 'letsbook'],
    createdAt: '2024/03/04',
    data: {
      title: 'O melhor hotel da Bahia é na Praia do Marinheiro',
      subtitle: 'Para você jamais esquecer',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam. Cras tincidunt arcu et ultricies ultrices. Morbi vel scelerisque odio. Donec porttitor orci lorem, vitae gravida diam cursus at. Pellentesque eu dolor vitae ipsum egestas maximus et at nisi.',
      buttonTextColor: '#ffffff',
      slides: [
        {
          image:
            'https://static.pmweb.com.br/q89ItkZsz14rX9EIvytUkpzs6V0=/https://letsimage.s3.sa-east-1.amazonaws.com/editor/preset/pt/_/1709212793525-photo-1699234726037-799bf98e821c.jpeg',
        },
        {
          image:
            'https://static.pmweb.com.br/kPnR0vcvRiFLki2vIXNiflfsga4=/https://letsimage.s3.sa-east-1.amazonaws.com/editor/preset/pt/_/1709212815439-photo-1698551599808-0157e2a1a214.jpeg',
        },
        {
          image:
            'https://static.pmweb.com.br/-K_i6-SkNbhs5pgJSR70eGoUyEA=/https://letsimage.s3.sa-east-1.amazonaws.com/editor/preset/pt/_/1708958905271-1687354829626-fotis-fotopoulos-sqh7__rxjc8-unsplash.jpg',
        },
        {
          image:
            'https://static.pmweb.com.br/M-sL2C2igiK6uRs9TL_1HL9VKHs=/https://letsimage.s3.sa-east-1.amazonaws.com/editor/preset/pt/_/1708958922707-1687354866389-young-kane-f_rmrzw4yn4-unsplash.jpg',
        },
        {
          image:
            'https://static.pmweb.com.br/97uam0Avq_hnj6ygf9dRTwvKdRU=/https://letsimage.s3.sa-east-1.amazonaws.com/editor/preset/pt/_/1708958941365-1687354889192-dubai-travel-blog-pqkq3jncore-unsplash.jpg',
        },
      ],
      buttons: [
        {
          buttonText: 'Reserve',
          buttonUrl: '',
          buttonFeatured: true,
        },
      ],
    },
  },
  {
    category: [moduleCategory.LETSBOOK, moduleCategory.PROMOTIONS],
    name: 'Promoções do Hotel',
    module: 'PromoHotel',
    createdAt: '2024/06/24',
    keywords: ['letsbook'],
    image: promoHotel,
    isEnabled({ hasLetsbookIntegration }) {
      return hasLetsbookIntegration;
    },
    data: {
      title: 'Nossas melhores ofertas',
      text: 'Veja nossas ofertas e desfrute dos melhores hotéis com descontos exclusivos',
    },
  },
].map((preset) => ({
  ...preset,
  isNew: isWithinLast30Days(preset.createdAt),
  isUpdated: isWithinLast30Days(preset.updatedAt),
}));

export default newFirst(orderList(presetList));
